'use strict';
module.exports = false;
try {
    module.exports = Object.prototype.toString.call(global.process) === '[object process]';
} catch (e) {
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/detect-node/index.js
// module id = 27
// module chunks = 0